import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { User } from '../entities/user';
import { map } from 'rxjs/operators';
import { UtilityService } from './utility.service';
import { Capacitor } from '@capacitor/core';
import { Observable, of } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class UserService {
  public user: User;

  constructor(
    private http: HttpClient,
    private utilityService: UtilityService,
  ) {}

  /**
   * This gets the logged in user from the server
   */
  getUser(): Observable<User> {
    if (environment.env !== 'dev' && !Capacitor.isNativePlatform()) {
      environment.rootDomainUrl = this.utilityService.getRootDomainUrl() + '/';
      environment.baseApiUrl = environment.rootDomainUrl + 'api/';
    }

    if (this.user) {
      return of(this.user);
    }

    return this.http.get(`${environment.baseApiUrl}user`, { withCredentials: true }).pipe(
      map((res) => {
        if (!res['error']) {
          this.user = new User(res);
          return this.user;
        }

        return new User();
      }),
    );
  }
}
